/**
 * @author Sarthak Sharma.
 * @since 31-01-2024.
 * @type {string} Project action types.
 */

export const SET_LOADING = '[RECRUITER_PROJECT] SET_LOADING';
export const SET_SELECTED_ROLES = '[RECRUITER_PROJECT] SET_SELECTED_ROLES';
export const SET_ACTIVE_PROJECT_LIST = '[RECRUITER_PROJECT] SET_ACTIVE_PROJECT_LIST';
export const SET_SELECTED_PROJECT = '[RECRUITER_PROJECT] SET_SELECTED_PROJECT';
export const SET_SELECTED_PROJECT_JOBS = '[RECRUITER_PROJECT] SET_SELECTED_PROJECT_JOBS';